setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.className === "cart__checkout-button button bg-color--green bg-hover--black text-color--black text-hover--white") {
              BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)



